(function () {
  'use strict';

  function relocateFrequentlyBoughtTogether() {
    var slot = document.querySelector('[data-sbs-fbt-slot]');
    var widget = document.querySelector('.cbb-frequently-bought-container');
    if (!slot || !widget) return false;

    if (!slot.contains(widget)) slot.appendChild(widget);
    widget.classList.add('sbs-fbt-widget');

    var form = widget.querySelector('.cbb-frequently-bought-form');
    var selectorList = widget.querySelector('.cbb-frequently-bought-selector-list');
    if (form && selectorList && selectorList.parentElement !== form) {
      form.insertBefore(selectorList, form.firstChild);
    }

    var addButton = widget.querySelector('.cbb-frequently-bought-add-button');
    if (addButton && addButton.textContent.trim() !== 'Add selected to bag') {
      addButton.textContent = 'Add selected to bag';
    }
    updateStickyDetail();
    return true;
  }

  function updateStickyDetail() {
    var detail = document.querySelector('.section-product-template .product-column-right');
    if (!detail) return;

    if (window.matchMedia('(max-width: 839px)').matches) {
      detail.style.removeProperty('--sbs-pdp-sticky-top');
      return;
    }

    var topGap = 96;
    var bottomGap = 24;
    var stickyTop = Math.min(topGap, window.innerHeight - detail.offsetHeight - bottomGap);
    detail.style.setProperty('--sbs-pdp-sticky-top', stickyTop + 'px');
  }

  function bindStickyDetail() {
    var detail = document.querySelector('.section-product-template .product-column-right');
    if (!detail) return;

    updateStickyDetail();
    window.addEventListener('resize', updateStickyDetail, { passive: true });
    detail.addEventListener('click', function (event) {
      if (!event.target.closest('button.accordion')) return;
      window.setTimeout(updateStickyDetail, 0);
    });
  }

  function observeFrequentlyBoughtTogether() {
    if (relocateFrequentlyBoughtTogether()) return;

    var observer = new MutationObserver(function () {
      if (relocateFrequentlyBoughtTogether()) observer.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true });
    window.setTimeout(function () {
      relocateFrequentlyBoughtTogether();
      observer.disconnect();
    }, 20000);
  }

  function setAddToBagLabel() {
    var button = document.querySelector('.product-form input[type="submit"]');
    if (!button || button.disabled || /sold out|unavailable|coming soon/i.test(button.value)) return;
    button.value = 'Add to Bag';
  }

  function bindAddToBagLabel() {
    setAddToBagLabel();
    window.setTimeout(setAddToBagLabel, 500);
    window.setTimeout(setAddToBagLabel, 1500);
  }

  function bindVariantMedia() {
    if (!window.jQuery) return;
    window.jQuery(window).off('cc-variant-updated.sbsPdp').on('cc-variant-updated.sbsPdp', function (event, payload) {
      window.setTimeout(setAddToBagLabel, 0);
      var mediaId = payload && payload.variant && payload.variant.featured_media && payload.variant.featured_media.id;
      if (!mediaId || window.matchMedia('(max-width: 989px)').matches) return;
      var target = document.querySelector('[data-sbs-media-id="' + mediaId + '"]');
      var gallery = target && target.closest('.product-column-left');
      if (!target || !gallery) return;
      gallery.scrollTo({ top: Math.max(0, target.offsetTop - 8), behavior: 'smooth' });
    });
  }

  function initRecentlyViewed() {
    var section = document.querySelector('[data-sbs-recently-viewed]');
    var grid = document.querySelector('[data-sbs-recently-viewed-grid]');
    var productData = document.querySelector('[data-sbs-current-product]');
    if (!section || !grid || !productData) return;

    var current;
    var history = [];
    try {
      current = JSON.parse(productData.textContent);
      history = JSON.parse(window.localStorage.getItem('sbsRecentlyViewed') || '[]');
      if (!Array.isArray(history)) history = [];
    } catch (error) {
      return;
    }

    history.filter(function (item) {
      return item && item.handle && item.handle !== current.handle;
    }).slice(0, 4).forEach(function (item) {
      var card = document.createElement('a');
      var image = document.createElement('img');
      var details = document.createElement('span');
      var title = document.createElement('span');
      var price = document.createElement('span');
      card.className = 'sbs-recently-viewed__card';
      card.href = item.url;
      image.className = 'sbs-recently-viewed__image';
      image.src = item.image;
      image.alt = item.title;
      image.loading = 'lazy';
      details.className = 'sbs-recently-viewed__details';
      title.className = 'sbs-recently-viewed__name';
      title.textContent = item.title;
      price.className = 'sbs-recently-viewed__price theme-money money';
      price.textContent = item.price;
      details.append(title, price);
      card.append(image, details);
      grid.appendChild(card);
    });

    if (grid.children.length) section.hidden = false;
    try {
      window.localStorage.setItem('sbsRecentlyViewed', JSON.stringify([current].concat(history.filter(function (item) {
        return item && item.handle !== current.handle;
      })).slice(0, 8)));
    } catch (error) {
      // Browsing history is an enhancement; the product page must work without storage.
    }
  }

  function bindMobileCartCurtain(section) {
    var root = section.querySelector('[data-sbs-mobile-cart]');
    if (!root || root.dataset.sbsReady === 'true') return;

    var form = root.closest('form');
    var primarySubmit = form && form.querySelector('.quantity-submit-row__submit input[type="submit"]');
    var bar = root.querySelector('[data-sbs-mobile-cart-bar]');
    var trigger = root.querySelector('[data-sbs-mobile-cart-trigger]');
    var triggerLabel = root.querySelector('[data-sbs-mobile-cart-trigger-label]');
    var triggerPrice = root.querySelector('[data-sbs-mobile-cart-price]');
    var curtain = root.querySelector('[data-sbs-mobile-cart-curtain]');
    var optionsSlot = root.querySelector('[data-sbs-mobile-cart-options]');
    var curtainPrice = root.querySelector('[data-sbs-mobile-cart-sheet-price]');
    var selection = root.querySelector('[data-sbs-mobile-cart-selection]');
    var curtainAdd = root.querySelector('[data-sbs-mobile-cart-add]');
    var optionSelectors = form && form.querySelector('.option-selectors');
    var mobileMedia = window.matchMedia('(max-width: 839px)');
    if (!form || !primarySubmit || !bar || !trigger || !curtain || !curtainAdd) return;

    var hasOptions = root.dataset.hasOptions === 'true' && Boolean(optionSelectors);
    var optionsParent = optionSelectors && optionSelectors.parentNode;
    var optionsNextSibling = optionSelectors && optionSelectors.nextSibling;
    var selectionConfirmed = !hasOptions || new URLSearchParams(window.location.search).has('variant');
    var isOpen = false;
    var historyPushed = false;
    var pendingSubmit = false;
    var lastFocused = null;
    var visibilityFrame = null;
    root.dataset.sbsReady = 'true';

    function getSelectedOptions() {
      if (!optionSelectors) return [];
      return Array.prototype.map.call(optionSelectors.querySelectorAll('[data-single-option-selector]'), function (select) {
        var wrapper = select.closest('.selector-wrapper');
        var label = wrapper && wrapper.querySelector('label');
        return {
          label: label ? label.textContent.trim() : '',
          value: select.value || '',
        };
      }).filter(function (option) {
        return option.value;
      });
    }

    function restoreOptions() {
      if (!optionSelectors || !optionsParent || optionSelectors.parentNode === optionsParent) return;
      if (optionsNextSibling && optionsNextSibling.parentNode === optionsParent) {
        optionsParent.insertBefore(optionSelectors, optionsNextSibling);
      } else {
        optionsParent.appendChild(optionSelectors);
      }
    }

    function moveOptionsIntoCurtain() {
      if (optionSelectors && optionsSlot && optionSelectors.parentNode !== optionsSlot) {
        optionsSlot.appendChild(optionSelectors);
      }
    }

    function currentPriceText() {
      var currentPrice = section.querySelector('.price-container .current-price');
      return currentPrice ? currentPrice.textContent.trim() : '';
    }

    function selectedVariantIsUnavailable() {
      return primarySubmit.disabled || /sold out|unavailable|coming soon/i.test(primarySubmit.value || '');
    }

    function syncCurtainState() {
      var unavailable = selectedVariantIsUnavailable();
      var price = currentPriceText();
      var selectedOptions = getSelectedOptions();
      var selectedText = selectedOptions.map(function (option) {
        return option.label ? option.label + ': ' + option.value : option.value;
      }).join(' / ');

      if (price) {
        if (triggerPrice) triggerPrice.textContent = price;
        if (curtainPrice) curtainPrice.textContent = price;
      }
      if (selection) selection.textContent = selectedText;

      curtainAdd.disabled = unavailable;
      curtainAdd.textContent = unavailable ? 'Sold out' : 'Add to bag';

      if (!hasOptions) {
        trigger.disabled = unavailable;
        triggerLabel.textContent = unavailable ? 'Sold out' : 'Add to bag';
      } else {
        trigger.disabled = false;
        triggerLabel.textContent = unavailable && selectionConfirmed ? 'Sold out' : 'Add to bag';
      }
    }

    function updateBarVisibility() {
      visibilityFrame = null;
      if (!mobileMedia.matches || isOpen) {
        bar.hidden = true;
        document.body.classList.remove('sbs-mobile-cart-bar-visible');
        return;
      }

      bar.hidden = false;
      document.body.classList.add('sbs-mobile-cart-bar-visible');
    }

    function requestVisibilityUpdate() {
      if (visibilityFrame !== null) return;
      visibilityFrame = window.requestAnimationFrame(updateBarVisibility);
    }

    function getFocusableElements() {
      return Array.prototype.filter.call(
        curtain.querySelectorAll('button:not([disabled]), a[href], select:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'),
        function (element) {
          return element.offsetParent !== null;
        }
      );
    }

    function finishClose() {
      if (!isOpen) return;
      isOpen = false;
      root.classList.remove('is-open');
      document.body.classList.remove('sbs-mobile-cart-open');
      curtain.setAttribute('aria-hidden', 'true');
      trigger.setAttribute('aria-expanded', 'false');
      restoreOptions();
      syncCurtainState();
      requestVisibilityUpdate();

      if (pendingSubmit) {
        pendingSubmit = false;
        window.requestAnimationFrame(function () {
          primarySubmit.click();
        });
      } else if (lastFocused && document.contains(lastFocused)) {
        lastFocused.focus({ preventScroll: true });
      }
    }

    function closeCurtain(skipHistory) {
      if (!isOpen) return;
      if (historyPushed && !skipHistory) {
        window.history.back();
        return;
      }
      historyPushed = false;
      finishClose();
    }

    function openCurtain() {
      if (!mobileMedia.matches || isOpen) return;
      isOpen = true;
      lastFocused = document.activeElement;
      moveOptionsIntoCurtain();
      syncCurtainState();
      root.classList.add('is-open');
      document.body.classList.add('sbs-mobile-cart-open');
      document.body.classList.remove('sbs-mobile-cart-bar-visible');
      curtain.setAttribute('aria-hidden', 'false');
      trigger.setAttribute('aria-expanded', 'true');
      bar.hidden = true;

      try {
        window.history.pushState({ sbsMobileCartCurtain: true }, '', window.location.href);
        historyPushed = true;
      } catch (error) {
        historyPushed = false;
      }

      window.requestAnimationFrame(function () {
        var closeButton = curtain.querySelector('.sbs-mobile-cart__close');
        if (closeButton) closeButton.focus({ preventScroll: true });
      });
    }

    function submitFromCurtain() {
      if (curtainAdd.disabled) return;
      selectionConfirmed = true;
      pendingSubmit = true;
      closeCurtain(false);
      if (!historyPushed && isOpen) finishClose();
    }

    trigger.addEventListener('click', function () {
      if (hasOptions && (!selectionConfirmed || selectedVariantIsUnavailable())) {
        openCurtain();
        return;
      }
      if (!primarySubmit.disabled) primarySubmit.click();
    });

    curtainAdd.addEventListener('click', submitFromCurtain);
    root.querySelectorAll('[data-sbs-mobile-cart-close]').forEach(function (button) {
      button.addEventListener('click', function () {
        pendingSubmit = false;
        closeCurtain(false);
      });
    });

    form.addEventListener('change', function (event) {
      if (!event.target.matches('[data-single-option-selector]')) return;
      selectionConfirmed = true;
      window.setTimeout(syncCurtainState, 0);
    });

    form.addEventListener('click', function (event) {
      if (!event.target.closest('.option-selectors .clickyboxes a')) return;
      selectionConfirmed = true;
      window.setTimeout(syncCurtainState, 0);
    });

    curtain.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        pendingSubmit = false;
        closeCurtain(false);
        return;
      }
      if (event.key !== 'Tab') return;

      var focusable = getFocusableElements();
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    window.addEventListener('popstate', function () {
      if (!isOpen) return;
      historyPushed = false;
      finishClose();
    });
    window.addEventListener('scroll', requestVisibilityUpdate, { passive: true });
    window.addEventListener('resize', requestVisibilityUpdate, { passive: true });

    if (window.jQuery) {
      window.jQuery(window).off('cc-variant-updated.sbsMobileCart').on('cc-variant-updated.sbsMobileCart', function () {
        window.setTimeout(syncCurtainState, 0);
      });
    }

    var stateObserver = new MutationObserver(syncCurtainState);
    stateObserver.observe(primarySubmit, { attributes: true, attributeFilter: ['disabled', 'value'] });
    var priceNode = section.querySelector('.price-container .price-area');
    if (priceNode) stateObserver.observe(priceNode, { childList: true, subtree: true });

    syncCurtainState();
    updateBarVisibility();
  }

  function bindCouponCopy(section) {
    var button = section.querySelector('[data-sbs-copy-coupon]');
    if (!button || button.dataset.sbsCouponReady === 'true') return;

    var action = button.querySelector('[data-sbs-coupon-action]');
    var resetTimer;
    button.dataset.sbsCouponReady = 'true';

    function showCopiedState() {
      if (!action) return;
      action.textContent = 'Copied';
      window.clearTimeout(resetTimer);
      resetTimer = window.setTimeout(function () {
        action.textContent = 'Copy';
      }, 1800);
    }

    function fallbackCopy(value) {
      var textarea = document.createElement('textarea');
      textarea.value = value;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);
      textarea.select();

      var copied = false;
      try {
        copied = document.execCommand('copy');
      } catch (error) {
        copied = false;
      }

      textarea.remove();
      button.focus();
      return copied;
    }

    button.addEventListener('click', function () {
      var code = button.getAttribute('data-code') || 'TRYSAND';

      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(code).then(showCopiedState).catch(function () {
          if (fallbackCopy(code)) showCopiedState();
        });
        return;
      }

      if (fallbackCopy(code)) showCopiedState();
    });
  }

  function bindOfferSlider(section) {
    var slider = section.querySelector('[data-sbs-offer-slider]');
    if (!slider || slider.dataset.sbsOfferReady === 'true') return;

    var track = slider.querySelector('[data-sbs-offer-track]');
    var slides = Array.prototype.slice.call(slider.querySelectorAll('[data-sbs-offer-slide]'));
    var dots = Array.prototype.slice.call(slider.querySelectorAll('[data-sbs-offer-dot]'));
    var previous = slider.querySelector('[data-sbs-offer-prev]');
    var next = slider.querySelector('[data-sbs-offer-next]');
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var current = 0;
    var timer;
    var pointerStartX = null;

    if (!track || slides.length < 2) return;
    slider.dataset.sbsOfferReady = 'true';

    function setFocusableState(slide, active) {
      slide.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach(function (element) {
        if (active) {
          if (element.dataset.sbsOfferTabindex !== undefined) {
            if (element.dataset.sbsOfferTabindex) {
              element.setAttribute('tabindex', element.dataset.sbsOfferTabindex);
            } else {
              element.removeAttribute('tabindex');
            }
            delete element.dataset.sbsOfferTabindex;
          }
          return;
        }

        if (element.dataset.sbsOfferTabindex === undefined) {
          element.dataset.sbsOfferTabindex = element.getAttribute('tabindex') || '';
        }
        element.setAttribute('tabindex', '-1');
      });
    }

    function showSlide(index) {
      current = (index + slides.length) % slides.length;
      track.style.transform = 'translate3d(-' + (current * 100) + '%, 0, 0)';

      slides.forEach(function (slide, slideIndex) {
        var active = slideIndex === current;
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        setFocusableState(slide, active);
      });

      dots.forEach(function (dot, dotIndex) {
        var active = dotIndex === current;
        dot.classList.toggle('is-active', active);
        if (active) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
    }

    function stopAutoplay() {
      window.clearInterval(timer);
      timer = null;
    }

    function startAutoplay() {
      if (reducedMotion || timer || document.hidden) return;
      timer = window.setInterval(function () {
        showSlide(current + 1);
      }, 4800);
    }

    function restartAutoplay() {
      stopAutoplay();
      startAutoplay();
    }

    if (previous) {
      previous.addEventListener('click', function () {
        showSlide(current - 1);
        restartAutoplay();
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        showSlide(current + 1);
        restartAutoplay();
      });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        showSlide(Number(dot.getAttribute('data-sbs-offer-dot')) || 0);
        restartAutoplay();
      });
    });

    slider.addEventListener('mouseenter', stopAutoplay);
    slider.addEventListener('mouseleave', startAutoplay);
    slider.addEventListener('focusin', stopAutoplay);
    slider.addEventListener('focusout', function (event) {
      if (!slider.contains(event.relatedTarget)) startAutoplay();
    });
    slider.addEventListener('pointerdown', function (event) {
      pointerStartX = event.clientX;
    });
    slider.addEventListener('pointerup', function (event) {
      if (pointerStartX === null) return;
      var distance = event.clientX - pointerStartX;
      pointerStartX = null;
      if (Math.abs(distance) < 40) return;
      showSlide(current + (distance < 0 ? 1 : -1));
      restartAutoplay();
    });
    slider.addEventListener('pointercancel', function () {
      pointerStartX = null;
    });
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        stopAutoplay();
      } else {
        startAutoplay();
      }
    });

    showSlide(0);
    startAutoplay();
  }

  function bindPresentmentCurrencyFormats() {
    if (window.__sbsPresentmentCurrencyFormatsBound) return;
    window.__sbsPresentmentCurrencyFormatsBound = true;

    var attempts = 0;
    var formatOverrides = {
      AED: {
        money_format: 'AED {{amount}}',
        money_with_currency_format: 'AED {{amount}}'
      },
      SAR: {
        money_format: 'SAR {{amount}}',
        money_with_currency_format: 'SAR {{amount}}'
      },
      CAD: {
        money_format: 'C${{amount}}',
        money_with_currency_format: 'C${{amount}} CAD'
      }
    };
    var repairTimer = null;

    function currencyLabel(code, value) {
      var text = value.trim();
      if (code === 'AED' && !/\bAED\b|د\.?\s?إ/i.test(text)) return 'AED ' + text;
      if (code === 'SAR' && !/\b(?:SAR|SR)\b/i.test(text)) return 'SAR ' + text;
      if (code === 'CAD' && !/\bCAD\b|C\$/i.test(text)) {
        return text.indexOf('$') > -1 ? 'C' + text : 'CAD ' + text;
      }
      return text;
    }

    function repairCurrencyLabels() {
      var currencyApi = window.DoublyGlobalCurrency;
      var selector = document.querySelector('[name="doubly-currencies"]');
      var selectedCurrency = selector ? selector.value : '';
      var hasUnconvertedPrice = document.querySelector('.money:not([doubly-currency])');
      if (
        currencyApi &&
        typeof currencyApi.convertAll === 'function' &&
        selectedCurrency &&
        selectedCurrency !== (window.DoublyGlobal && window.DoublyGlobal.shopCurrency) &&
        hasUnconvertedPrice
      ) {
        currencyApi.convertAll(selectedCurrency);
      }

      document.querySelectorAll('.money[doubly-currency]').forEach(function (money) {
        var code = (money.getAttribute('doubly-currency') || '').toUpperCase();
        if (!formatOverrides[code]) return;
        var repaired = currencyLabel(code, money.textContent);
        if (repaired !== money.textContent.trim()) money.textContent = repaired;
      });

      var mainPrice = document.querySelector('.current-price');
      if (!mainPrice) return;
      var mainText = mainPrice.textContent.trim();
      document.querySelectorAll(
        '[data-sbs-mobile-cart-price], [data-sbs-mobile-cart-sheet-price]'
      ).forEach(function (price) {
        if (price.textContent.trim() !== mainText) price.textContent = mainText;
      });
    }

    function scheduleCurrencyLabelRepair() {
      window.clearTimeout(repairTimer);
      repairTimer = window.setTimeout(repairCurrencyLabels, 0);
    }

    function applyFormats() {
      var currencyApi = window.DoublyGlobalCurrency;
      if (!currencyApi || !currencyApi.moneyFormats) {
        attempts += 1;
        if (attempts < 40) window.setTimeout(applyFormats, 250);
        return;
      }

      Object.keys(formatOverrides).forEach(function (currencyCode) {
        currencyApi.moneyFormats[currencyCode] = Object.assign(
          {},
          currencyApi.moneyFormats[currencyCode] || {},
          formatOverrides[currencyCode]
        );
      });

      var selector = document.querySelector('[name="doubly-currencies"]');
      if (selector && selector.value && typeof currencyApi.convertAll === 'function') {
        currencyApi.convertAll(selector.value);
      }
      scheduleCurrencyLabelRepair();
    }

    var currencyObserver = new MutationObserver(scheduleCurrencyLabelRepair);
    currencyObserver.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
    applyFormats();
  }


  function bindProductImageViewer(section) {
    if (!section || section.dataset.sbsImageViewerReady === 'true') return;

    var imageSelector = [
      '.sbs-pdp-media-grid__item--image .sbs-pdp-media-grid__image',
      '.sbs-pdp-media-grid__item--packaging .sbs-pdp-media-grid__image',
      '.product-slideshow .product-media--image img',
      '.product-slideshow .slide > img'
    ].join(',');
    var viewer = document.querySelector('[data-sbs-pdp-image-viewer]');

    if (!viewer) {
      viewer = document.createElement('div');
      viewer.className = 'sbs-pdp-image-viewer';
      viewer.hidden = true;
      viewer.setAttribute('data-sbs-pdp-image-viewer', '');
      viewer.setAttribute('role', 'dialog');
      viewer.setAttribute('aria-modal', 'true');
      viewer.setAttribute('aria-label', 'Product image viewer');
      viewer.innerHTML = [
        '<button class="sbs-pdp-image-viewer__close" type="button" data-sbs-image-viewer-close aria-label="Close image viewer">',
          '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 5l14 14M19 5L5 19"/></svg>',
        '</button>',
        '<div class="sbs-pdp-image-viewer__stage" data-sbs-image-viewer-stage>',
          '<div class="sbs-pdp-image-viewer__canvas" data-sbs-image-viewer-canvas>',
            '<img class="sbs-pdp-image-viewer__image" data-sbs-image-viewer-image alt="">',
          '</div>',
        '</div>',
        '<div class="sbs-pdp-image-viewer__controls" aria-label="Image zoom controls">',
          '<button type="button" data-sbs-image-viewer-zoom-out aria-label="Zoom out">',
            '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 12h12"/></svg>',
          '</button>',
          '<output data-sbs-image-viewer-scale aria-live="polite">100%</output>',
          '<button type="button" data-sbs-image-viewer-zoom-in aria-label="Zoom in">',
            '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 6v12M6 12h12"/></svg>',
          '</button>',
        '</div>'
      ].join('');
      document.body.appendChild(viewer);
    }

    var stage = viewer.querySelector('[data-sbs-image-viewer-stage]');
    var canvas = viewer.querySelector('[data-sbs-image-viewer-canvas]');
    var viewerImage = viewer.querySelector('[data-sbs-image-viewer-image]');
    var closeButton = viewer.querySelector('[data-sbs-image-viewer-close]');
    var zoomOutButton = viewer.querySelector('[data-sbs-image-viewer-zoom-out]');
    var zoomInButton = viewer.querySelector('[data-sbs-image-viewer-zoom-in]');
    var scaleOutput = viewer.querySelector('[data-sbs-image-viewer-scale]');
    var scale = 1;
    var baseWidth = 0;
    var baseHeight = 0;
    var isOpen = false;
    var previousFocus = null;
    var pinchDistance = 0;
    var pinchScale = 1;

    if (!stage || !canvas || !viewerImage || !closeButton || !zoomOutButton || !zoomInButton) return;
    section.dataset.sbsImageViewerReady = 'true';

    function normalizeSource(source) {
      if (!source) return '';
      return source
        .replace(/\{width\}/g, '2400')
        .replace(/_1x1(\.[a-z0-9]+)(?:\?.*)?$/i, '_2400x$1');
    }

    function largestSrcsetCandidate(srcset) {
      if (!srcset) return '';
      return srcset.split(',').map(function (candidate) {
        var parts = candidate.trim().split(/\s+/);
        return {
          url: parts[0] || '',
          width: parseInt(parts[1], 10) || 0
        };
      }).sort(function (left, right) {
        return right.width - left.width;
      })[0]?.url || '';
    }

    function imageSource(image) {
      var templateSource = image.getAttribute('data-src');
      if (templateSource && templateSource.indexOf('{width}') > -1) {
        return normalizeSource(templateSource);
      }

      var srcsetSource = largestSrcsetCandidate(
        image.getAttribute('srcset') || image.getAttribute('data-srcset')
      );
      if (srcsetSource) return normalizeSource(srcsetSource);

      var galleryLink = image.closest('a.show-gallery');
      if (galleryLink && galleryLink.href) return galleryLink.href;
      return normalizeSource(image.currentSrc || image.src);
    }

    function updateZoom(nextScale, preserveCenter) {
      if (!baseWidth || !baseHeight) return;
      var previousScrollWidth = Math.max(stage.scrollWidth, 1);
      var previousScrollHeight = Math.max(stage.scrollHeight, 1);
      var centerX = (stage.scrollLeft + stage.clientWidth / 2) / previousScrollWidth;
      var centerY = (stage.scrollTop + stage.clientHeight / 2) / previousScrollHeight;

      scale = Math.max(1, Math.min(4, Math.round(nextScale * 10) / 10));
      var scaledWidth = Math.round(baseWidth * scale);
      var scaledHeight = Math.round(baseHeight * scale);
      canvas.style.width = Math.max(stage.clientWidth, scaledWidth) + 'px';
      canvas.style.height = Math.max(stage.clientHeight, scaledHeight) + 'px';
      viewerImage.style.width = scaledWidth + 'px';
      viewerImage.style.height = scaledHeight + 'px';
      viewerImage.dataset.zoomed = scale > 1 ? 'true' : 'false';
      zoomOutButton.disabled = scale <= 1;
      zoomInButton.disabled = scale >= 4;
      if (scaleOutput) scaleOutput.value = Math.round(scale * 100) + '%';

      window.requestAnimationFrame(function () {
        if (preserveCenter) {
          stage.scrollLeft = centerX * stage.scrollWidth - stage.clientWidth / 2;
          stage.scrollTop = centerY * stage.scrollHeight - stage.clientHeight / 2;
        } else {
          stage.scrollLeft = Math.max(0, (stage.scrollWidth - stage.clientWidth) / 2);
          stage.scrollTop = Math.max(0, (stage.scrollHeight - stage.clientHeight) / 2);
        }
      });
    }

    function fitImage() {
      if (!viewerImage.naturalWidth || !viewerImage.naturalHeight) return;
      var availableWidth = Math.max(1, stage.clientWidth - 32);
      var availableHeight = Math.max(1, stage.clientHeight - 32);
      var ratio = Math.min(
        availableWidth / viewerImage.naturalWidth,
        availableHeight / viewerImage.naturalHeight,
        1
      );
      baseWidth = Math.round(viewerImage.naturalWidth * ratio);
      baseHeight = Math.round(viewerImage.naturalHeight * ratio);
      updateZoom(1, false);
    }

    function focusableElements() {
      return Array.prototype.filter.call(
        viewer.querySelectorAll('button:not([disabled]), [href], [tabindex]:not([tabindex="-1"])'),
        function (element) {
          return element.offsetParent !== null;
        }
      );
    }

    function closeViewer() {
      if (!isOpen) return;
      isOpen = false;
      viewer.hidden = true;
      viewer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('sbs-pdp-image-viewer-open');
      viewerImage.removeAttribute('src');
      viewerImage.alt = '';
      baseWidth = 0;
      baseHeight = 0;
      if (previousFocus && document.contains(previousFocus)) {
        previousFocus.focus({ preventScroll: true });
      }
    }

    function openViewer(sourceImage) {
      var source = imageSource(sourceImage);
      if (!source) return;
      previousFocus = document.activeElement;
      isOpen = true;
      scale = 1;
      viewerImage.alt = sourceImage.alt || 'Product image';
      viewerImage.src = source;
      viewer.hidden = false;
      viewer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('sbs-pdp-image-viewer-open');
      closeButton.focus({ preventScroll: true });
      if (viewerImage.complete) fitImage();
    }

    section.querySelectorAll(imageSelector).forEach(function (image) {
      image.classList.add('sbs-pdp-image-viewer-source');
      image.setAttribute('tabindex', '0');
      image.setAttribute('role', 'button');
      image.setAttribute('aria-label', 'Open product image viewer');
    });

    section.addEventListener('click', function (event) {
      if (!(event.target instanceof Element)) return;
      var sourceImage = event.target.closest(imageSelector);
      if (!sourceImage || !section.contains(sourceImage)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      openViewer(sourceImage);
    }, true);

    section.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      if (!(event.target instanceof Element) || !event.target.matches(imageSelector)) return;
      event.preventDefault();
      openViewer(event.target);
    });

    viewerImage.addEventListener('load', fitImage);
    closeButton.addEventListener('click', closeViewer);
    zoomOutButton.addEventListener('click', function () {
      updateZoom(scale - 0.5, true);
    });
    zoomInButton.addEventListener('click', function () {
      updateZoom(scale + 0.5, true);
    });
    viewerImage.addEventListener('dblclick', function () {
      updateZoom(scale > 1 ? 1 : 2, true);
    });
    viewer.addEventListener('click', function (event) {
      if (event.target === viewer || event.target === stage || event.target === canvas) {
        closeViewer();
      }
    });
    viewer.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        closeViewer();
        return;
      }
      if (event.key === '+' || event.key === '=') {
        event.preventDefault();
        updateZoom(scale + 0.5, true);
        return;
      }
      if (event.key === '-' || event.key === '_') {
        event.preventDefault();
        updateZoom(scale - 0.5, true);
        return;
      }
      if (event.key !== 'Tab') return;

      var focusable = focusableElements();
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
    stage.addEventListener('touchstart', function (event) {
      if (event.touches.length !== 2) return;
      var horizontal = event.touches[0].clientX - event.touches[1].clientX;
      var vertical = event.touches[0].clientY - event.touches[1].clientY;
      pinchDistance = Math.hypot(horizontal, vertical);
      pinchScale = scale;
    }, { passive: true });
    stage.addEventListener('touchmove', function (event) {
      if (event.touches.length !== 2 || !pinchDistance) return;
      event.preventDefault();
      var horizontal = event.touches[0].clientX - event.touches[1].clientX;
      var vertical = event.touches[0].clientY - event.touches[1].clientY;
      var distance = Math.hypot(horizontal, vertical);
      updateZoom(pinchScale * distance / pinchDistance, true);
    }, { passive: false });
    stage.addEventListener('touchend', function () {
      pinchDistance = 0;
    }, { passive: true });
    window.addEventListener('resize', function () {
      if (isOpen) fitImage();
    }, { passive: true });
  }

  function init() {
    var section = document.querySelector('.section-product-template');
    if (!section || section.dataset.sbsPdpReady === 'true') return;
    section.dataset.sbsPdpReady = 'true';
    bindProductImageViewer(section);
    bindPresentmentCurrencyFormats();
    observeFrequentlyBoughtTogether();
    bindStickyDetail();
    bindVariantMedia();
    bindAddToBagLabel();
    initRecentlyViewed();
    bindOfferSlider(section);
    bindCouponCopy(section);
    bindMobileCartCurtain(section);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
}());
